import { render, staticRenderFns } from "./AccountIdentitySection.vue?vue&type=template&id=963bdf96"
import script from "./AccountIdentitySection.vue?vue&type=script&lang=js"
export * from "./AccountIdentitySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports